<app-features-container
  actionButtonName="{{
    '+INSTALLATIONS.INSTALLATION.FEATURE_CONTAINER.DETAILS_BUTTON' | translate
  }}"
  [header]="'+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.TITLE' | translate"
  [overlayType]="featuresDetailsOverlayTypeEnum.HybridProControl"
>
  <!-- heating.configuration.secondaryHeatGenerator -->
  <app-feature-tile
    *ngIf="controlMode$ | async | ready as feature"
    feature
    label="{{ '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.CONTROL_MODE.TITLE' | translate }}"
    [value]="feature | value2: featurePropertyKey.value | hybridProGeneratorModes"
    [attr.data-feature]="feature.feature"
  ></app-feature-tile>

  <!-- heating.secondaryHeatGenerator.operating.modes.active  -->
  <app-feature-tile
    *ngIf="controlStrategy$ | async | ready as feature"
    feature
    label="{{ '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.CONTROL_STRATEGY.TITLE' | translate }}"
    [value]="feature | value2: featurePropertyKey.value | hybridProOperatingModesActive"
    [attr.data-feature]="feature.feature"
  ></app-feature-tile>

  <!-- heating.secondaryHeatGenerator.temperature.offset -->
  <app-feature-tile
    *ngIf="temperatureOffset$ | async | ready as feature"
    feature
    label="{{
      '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.TEMPERATURE_OFFSET.TITLE' | translate
    }}"
    value="{{ feature | value2: featurePropertyKey.value }} {{
      feature | unit: featurePropertyKey.value
    }}"
    [attr.data-feature]="feature.feature"
  ></app-feature-tile>
</app-features-container>
